import { type ClipWindow } from "../clipTrack";

export type ClipPresetBarProps = {
  duration: number;
  window: ClipWindow;
  onSetWindow: (window: ClipWindow) => void;
  onSetIn: () => void;
  onSetOut: () => void;
};

/** Compact duration controls from the approved Review editor dock. */
export function ClipPresetBar({
  duration,
  window,
  onSetWindow,
  onSetIn,
  onSetOut,
}: ClipPresetBarProps) {
  const setDuration = (seconds: number) => {
    const start = Math.min(window.start, Math.max(0, duration - seconds));
    onSetWindow({ start, end: Math.min(duration, start + seconds) });
  };

  return (
    <div className="editor-clip-actions-core" data-testid="coach-review-clip-preset-bar">
      <button type="button" className="editor-button" onClick={onSetIn} data-testid="clip-preset-set-in">
        Set IN here
      </button>
      <button type="button" className="editor-button" onClick={onSetOut} data-testid="clip-preset-set-out">
        Set OUT here
      </button>
      <div className="editor-presets" role="group" aria-label="Clip duration presets">
        {[10, 20, 30].map((seconds) => (
          <button
            key={seconds}
            type="button"
            className="editor-button"
            onClick={() => setDuration(seconds)}
            data-testid={`clip-preset-${seconds}`}
            aria-label={`Set clip to ${seconds} seconds`}
          >
            {seconds}s
          </button>
        ))}
      </div>
    </div>
  );
}
